import PropTypes from "prop-types";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Tab from "../components/navigation/Tab.js";
import AdminLayout from "./AdminLayout.js";

const AdminCourseLayout = ({ courseId, children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const labels = [
    "Informações do Curso",
    "Inscrições",
    "Avaliação",
    "Conteúdos Pedagógicos",
    "Questionários de Satisfação",
  ];
  const urls = ["/", "/enrollments", "/quizzes", "/learning", "/surveys"];

  // find from index 1 because first index will always return true ("/"). besides, +1 will make it so that -1 --> 0
  const selectedTab =
    urls.slice(1).findIndex((url) => location.pathname.includes(url)) + 1;

  return (
    <AdminLayout title="Cursos Online">
      {courseId && (
        <Tab
          labels={labels}
          selected={selectedTab}
          onSelectTab={(tab) =>
            navigate(`/admin/courses/${courseId}/edit${urls[tab]}`)
          }
        />
      )}
      {children}
    </AdminLayout>
  );
};

AdminCourseLayout.propTypes = {
  courseId: PropTypes.string.isRequired,
};

export default AdminCourseLayout;
